<template>
  <BaseSection
    heading="Basuppgifter"
    :infoStatus="basuppgifter.infoStatus"
    :show-error="!!basuppgifter.error"
  >
    <section-row title="Anmälda Collectum" :value="basuppgifter.data?.anmaldaCollectum ?? null">
      <section-row title="ITP1" :value="basuppgifter.data?.itp1 ?? null" />
      <section-row title="ITP2" :value="basuppgifter.data?.itp2 ?? null" />
      <section-row title="Pensioneringsavtal" :value="basuppgifter.data?.pensioneringsavtal ?? null" />
      <section-row title="PRI-modellen används" :value="formatAsYesOrNo(basuppgifter.data?.priModellenAnvands)" />
    </section-row>
    <section-row title="Alternativ pensionslösning" :value="basuppgifter.data?.alternativPensionslosning ?? null" />
    <section-row title="Premiebefriade inom ITP2" :value="basuppgifter.data?.premiebefriadeInomItp2 ?? null" />
    <section-row title="Utlandsanställda" :value="basuppgifter.data?.utlandsanstallda ?? null" />
    <section-row title="Undantagna från ITP" :value="basuppgifter.data?.undantagnaFranItp ?? null" />
    <section-row title="Nyanmälda" :value="basuppgifter.data?.nyanmalda ?? null" />
    <section-row title="Avanmälda" :value="basuppgifter.data?.avanmalda ?? null" />
  </BaseSection>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { BaseSection, SectionRow } from "@/components/sections";
import { formatAsYesOrNo } from "@/common/formatters";

import { useArbetsgivareStore } from "../../store";

export type Basuppgifter = {
  anmaldaCollectum?: number | null;
  itp1?: number | null;
  itp2?: number | null;
  pensioneringsavtal?: string | null;
  priModellenAnvands?: boolean | null;
  sjukanmalda?: number | null;
  alternativPensionslosning?: number | null;
  premiebefriadeInomItp2?: number | null;
  utlandsanstallda?: number | null;
  undantagnaFranItp?: number | null;
  nyanmalda?: number | null;
  avanmalda?: number | null;
};

const arbetsgivareStore = useArbetsgivareStore();
const basuppgifter = computed(() => arbetsgivareStore.basuppgifterSection);
</script>
